// extracted by mini-css-extract-plugin
module.exports = {"content":"Modal_fasting_content__3C87M","buttons":"Modal_fasting_buttons__GUvrU"};